import React from 'react';
import type { FC } from 'react';

interface CheckIconProps {
    className?: string;
    size?: number;
    title?: string;
}

export const CheckIcon: FC<CheckIconProps> = ({ className, size = 18, title = '' }) => {
    return (
        <svg
            width={size}
            height={size}
            className={className}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>{title}</title>
            <rect x="4" y="4" width="12" height="12" rx="1" fill="#3A50FF" />
            <path d="M7 10L8.64645 11.6464C8.84171 11.8417 9.15829 11.8417 9.35355 11.6464L13 8" stroke="white" />
        </svg>
    );
};
